import React, { useEffect, useState } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//style
import styles from 'src/asset/scss/style/dashboard.module.scss'

export default React.memo(function SisData(props) {
    const { startDate, endDate } = props;
    const { axiosPostHandler } = useAxiosHook();//axios
    const { socket } = useComnStore();
    const { isState, partner } = usePartnerStore();

    /* =============== 당일집계내역 =============== */
    const [ dailyCount, setDailyCount ] = useState({});
    const dashboardDailyCountAPI = async () => {
        const DATA = { PARTNER_CD:partner.COMN_CD };
        const result = await axiosPostHandler(`partnerDashboardSisForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; } 
        if(result.message === "SUCCESS") {
            setDailyCount(result.data);
        }
    };
    useEffect(() => {
        if(!isState) { return; }
        
        dashboardDailyCountAPI();
    }, [isState, startDate, endDate, socket])
    /* =============== 당일집계내역 =============== */

    return (
        <ul className={styles.dailyCountDataContainer}>
            <li><h1>새 요청</h1><label>총 {dailyCount.CNT_1 ?? 0}건</label></li>
            <li><h2>당일 예약 건수</h2><span>{dailyCount.CNT_2 ?? 0}건</span></li>
            <li><h2>이력 미작성 건수</h2><span>{dailyCount.CNT_3 ?? 0}건</span></li>
        </ul>
    );
})